import { render, staticRenderFns } from "./TabelaPreco.vue?vue&type=template&id=17c705e7&scoped=true"
import script from "./TabelaPreco.vue?vue&type=script&lang=js"
export * from "./TabelaPreco.vue?vue&type=script&lang=js"
import style0 from "./TabelaPreco.vue?vue&type=style&index=0&id=17c705e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c705e7",
  null
  
)

export default component.exports